export const FIELDS = ['1', '2', '3', '4', '5', '6'];
export const TEMPLATE_INPUT_ID = 'TEMPLATE_INPUT_ID';
